import { LevelPlayStories as Activity } from '.'

export const SLUG = 'stories'
export const activity = {
  SLUG,
  customContent: true,
  interactionMode: {
    kind: 'continue',
    waitValidation: false
  },
  Component: Activity
}
